import { AlignmentContainer, CaptionContainer } from "@piperunner-cms/component/RTERenderer/common";
import type { NodeProps } from "@tiptap/static-renderer/json/react";
import type { EmbedAttributes } from "../type";
import styles from "./EmbedNodeView.module.css";

function EmbedNodeView({ node }: NodeProps) {
  const { src, width, align, minWidth, maxWidth, caption, aspectRatio, allowfullscreen } =
    node.attrs as EmbedAttributes;

  return (
    <AlignmentContainer
      align={align}
      wrapperStyle={{
        width,
        minWidth,
        maxWidth,
        aspectRatio,
      }}
    >
      <CaptionContainer caption={caption}>
        <iframe title={caption ?? "Embed"} className={styles.embedStyles} src={src} allowFullScreen={allowfullscreen} />
      </CaptionContainer>
    </AlignmentContainer>
  );
}

export default EmbedNodeView;
